import { EmployeeName } from "@src/components/employee_name/index";
import { RESOURCE_PLAN_CONFIRMATION_TYPE } from "@src/constants";
import { FrameworkComponents } from "@src/types/aggrid_types";
import { columnTypes, paginationGridOptions } from "@src/utils/aggrid_utils";
import { ColDef, GridOptions } from "ag-grid-community";
import { ValueFormatterParams, ValueGetterParams } from "ag-grid-enterprise";
import { CustomCellRendererProps } from "ag-grid-react";
import dayjs from "dayjs";

function getComponents(): FrameworkComponents {
  return {
    nameAvatarRenderer: (props: CustomCellRendererProps) => {
      return <EmployeeName name={props.value} />;
    },
  };
}

export const columnDefs: ColDef[] = [
  {
    headerName: "Date",
    field: "confirmationDate",
    filter: "agSetColumnFilter",
    valueFormatter: (params: ValueFormatterParams) => {
      return dayjs(params.value).format("DD/MM/YYYY");
    },
    filterValueGetter: (params: ValueGetterParams): string =>
      dayjs(params.data.confirmationDate).format("DD/MM/YYYY"),
  },
  {
    headerName: "Confirmed By",
    field: "confirmedByName",
    filter: "agSetColumnFilter",
    cellRenderer: "nameAvatarRenderer",
    valueGetter: (params: ValueGetterParams) => {
      return params.data.confirmedByName ?? "Deleted User";
    },
  },
  {
    headerName: "Confirmation Data",
    field: "confirmedType",
    filter: "agSetColumnFilter",
    valueFormatter: (params: ValueFormatterParams) => {
      return RESOURCE_PLAN_CONFIRMATION_TYPE[params.value];
    },
  },
];

export function getGridOptions(): GridOptions {
  return {
    ...paginationGridOptions,
    domLayout: "autoHeight",
    suppressContextMenu: true,
    components: getComponents(),
    columnDefs: columnDefs,
    defaultColDef: {
      ...columnTypes.default,
      resizable: false,
      flex: 1,
    },
  };
}
